import React from "react";
import { Formik, Form, Field } from "formik";
import { useNavigate } from "react-router-dom";
import { useData } from "../util/dataProvider";
import { Link } from "react-router-dom";
import MailIMG from "../assets/email.svg";
import UserIMG from "../assets/user.svg";
import PWIMG from "../assets/password.svg";

export default function Login() {
    const { signIn, authError, signUp, registerError, assetUrl } = useData();

    const history = useNavigate();
    return (
        <div id='Login'>
            <div className='left-part'>
                <div className='big-title'>Ich bin neu hier</div>
                <div className='normal-text'>
                    Registrieren Sie sich jetzt, um selbst als Expert*in oder
                    Unternehmen Teil des bergisch.metall Netzwerks zu werden.
                </div>
                <Formik
                    initialValues={{
                        email: "",
                        name: "",
                        password: "",
                    }}
                    onSubmit={(values) =>
                        signUp(values.email, values.password)
                    }>
                    <Form>
                        <label htmlFor='email' className='label'>
                            E-Mail Adresse
                        </label>
                        <div
                            id='email'
                            style={{
                                backgroundImage: `url(${assetUrl + MailIMG})`,
                            }}>
                            <Field name='email' type='email' />
                        </div>
                        <label htmlFor='name' className='label'>
                            Vollständiger Name
                        </label>
                        <div
                            id='name'
                            style={{
                                backgroundImage: `url(${assetUrl + UserIMG})`,
                            }}>
                            <Field name='name' type='text' />
                        </div>
                        <label htmlFor='password' className='label'>
                            Passwort
                        </label>
                        <div
                            id='password'
                            style={{
                                backgroundImage: `url(${assetUrl + PWIMG})`,
                            }}>
                            <Field name='password' type='password' />
                        </div>
                        <div className='label'>
                            Mit der Registrierung erklären Sie, dass Sie unsere
                            Datenschutzerklärung gelesen und zur Kenntnis
                            genommen haben.
                        </div>
                        <button className='button-green'>
                            Jetzt registrieren
                        </button>
                        {registerError && (
                            <div className='errors'>{registerError}</div>
                        )}
                    </Form>
                </Formik>
            </div>
            <div className='right-part'>
                <div className='big-title'>Ich habe ein Konto</div>
                <div className='normal-text'>
                    Melde Sie sich jetzt an, um Ihre Profile zu verwalten.
                    Klicken Sie <Link to='/password'>hier</Link>, wenn Sie Ihr
                    Passwort vergessen haben.
                </div>
                <Formik
                    initialValues={{
                        email: "",
                        password: "",
                    }}
                    onSubmit={(values) => signIn(values)}>
                    <Form>
                        <label htmlFor='email' className='label'>
                            E-Mail Adresse
                        </label>
                        <div
                            id='email'
                            style={{
                                backgroundImage: `url(${assetUrl + MailIMG})`,
                            }}>
                            <Field name='email' type='email' />
                        </div>
                        <label htmlFor='password' className='label'>
                            Passwort
                        </label>
                        <div
                            id='password'
                            style={{
                                backgroundImage: `url(${assetUrl + PWIMG})`,
                            }}>
                            <Field name='password' type='password' />
                        </div>
                        <button type='submit' className='button-green'>
                            Anmelden
                        </button>
                        {authError && <div className='errors'>{authError}</div>}
                    </Form>
                </Formik>
            </div>
        </div>
    );
}
